import { __decorate } from "tslib";
/**
 * 计算表格的高度，用来展示表格内容的滚动条
 * 注：表格父级在    flex-direction: column; flex: 1; overflow: auto; 里使用，会根据父级 flex 的高度自适应
 */
import { Component, Watch, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
let TableMaxHeightMixins = class TableMaxHeightMixins extends Vue {
    constructor() {
        super(...arguments);
        this.activatedFlag = false;
        this.isInItactivatedFlag = false;
        this.tableMaxHeight = 1000;
        this.tableScroll = {};
        this.scrollTop = 0;
        this.scrollListener = false;
    }
    getVisible() {
        this.getflexScrollHeight();
    }
    getflexScrollHeight() {
        if (this.activatedFlag) {
            this.$nextTick(() => {
                const flexScroll = this.$refs.flexScroll || {};
                if (flexScroll.$el) {
                    const scrollContent = flexScroll.$el.getElementsByClassName("pi-flex-scroll-content");
                    const contentDiv = scrollContent[0];
                    const div = contentDiv ? contentDiv : flexScroll.$el;
                    if (div.offsetHeight) {
                        if (div.firstChild) {
                            div.firstChild.style.display = "none";
                        }
                        this.tableMaxHeight = div.offsetHeight;
                        if (div.firstChild) {
                            div.firstChild.style.display = "block";
                        }
                    }
                }
                if (!this.isInItactivatedFlag) {
                    this.isInItactivatedFlag = true;
                }
            });
        }
    }
    getDiv() {
        // 监听滚动条的位置
        this.$nextTick(() => {
            const flexScroll = this.$refs.flexScroll || {};
            if (flexScroll.$el) {
                const table = flexScroll.$el;
                const tableScroll = table.getElementsByClassName("ivu-table-body")[0];
                if (tableScroll) {
                    this.tableScroll = tableScroll;
                    this.tableScroll.addEventListener("scroll", this.getDivScrollTop);
                    this.scrollListener = true;
                }
            }
        });
    }
    getDivScrollTop(e) {
        this.scrollTop = e.target.scrollTop;
        // console.log(this.scrollTop);
    }
    mounted() {
        this.activatedFlag = true;
        this.$nextTick(() => {
            this.getflexScrollHeight();
            this.getDiv();
        });
    }
    activated() {
        if (this.isInItactivatedFlag) {
            this.activatedFlag = true;
            this.getflexScrollHeight();
        }
        if (this.scrollListener) {
            this.tableScroll.addEventListener("scroll", this.getDivScrollTop);
            this.tableScroll.scrollTop = this.scrollTop;
        }
    }
    deactivated() {
        this.activatedFlag = false;
        if (this.scrollListener) {
            this.tableScroll.removeEventListener("scroll", this.getDivScrollTop);
        }
    }
};
__decorate([
    State("sys")
], TableMaxHeightMixins.prototype, "sys", void 0);
__decorate([
    Watch("sys.winOnresize")
], TableMaxHeightMixins.prototype, "getVisible", null);
TableMaxHeightMixins = __decorate([
    Component
], TableMaxHeightMixins);
export default TableMaxHeightMixins;
